module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "c4"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('h4', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "href": "#/html/003_toc#c4_"
    }
  }, [_vm._v("ON AFRICA")])]), _vm._v(" "), _c('p', {
    staticClass: "textfirst"
  }, [_vm._v("Africans are going to have to be responsible for their own salvation. We have to be partners with them in that process. The African-American community here has to be\n    attentive to their issues. On the flip side, African leaders have to create a rule of law that is not corrupt, that is transparent.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Essence")]), _vm._v(", October 2006")])]), _vm._v(" "), _c('div', {
    staticClass: "xpage"
  }, [_c('p', {
    staticClass: "textfirst2"
  }, [_vm._v("Black Americans have always had an ambiguous relationship with Africa. Nowadays, we wear "), _c('em', [_vm._v("kente")]), _vm._v(" cloth, celebrate Kwanza and put up posters of Nelson Mandela on our\n    walls. And when we travel to Africa and discover it’s not all sweetness and light, we can end up deeply disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "right2"
  }, [_c('em', [_vm._v("Crisis")]), _vm._v(", October 1995")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62657dba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/010_chap4.vue
// module id = 84
// module chunks = 0